import React from 'react'
import type { GoodsItem } from '../types'
import wxCode from '../images/enterprise/wx_code.png'
import photoRecycle from '../images/enterprise/photo_recycle.png'
import photoViewer from '../images/enterprise/photo_viewer.png'
import peopleService from '../images/enterprise/people_service.png'
import peopleMax from '../images/enterprise/people_max.png'
import photoDown from '../images/enterprise/photo_down.png'
import groupWatermark from '../images/enterprise/group_watermark.png'

interface Props {
  selectedGoods?: GoodsItem | null
  onBuy?: () => void
  /** 商品卡片上方自定义横幅（开通弹窗 cardBanner 插槽） */
  cardBanner?: React.ReactNode
}

const benefits = [
  {
    img: groupWatermark,
    title: '编辑/去水印',
    highlight: '无限量',
    subtitle: '额外多3.8万次，价值约3千元'
  },
  {
    img: photoViewer,
    title: '照片查看/下载权限',
    highlight: '查看/下载',
    subtitle: '保护照片数据，杜绝离职风险'
  },
  {
    img: photoRecycle,
    title: '团队照片',
    highlight: '回收站',
    subtitle: '防范重要照片丢失'
  },
  {
    img: peopleService,
    title: '专属大客户服务',
    highlight: '大客户',
    subtitle: '24小时专属在线服务群'
  },
  {
    img: peopleMax,
    title: '人数上限',
    highlight: '300人',
    subtitle: '超大空间内存无忧'
  },
  {
    img: photoDown,
    title: '照片可',
    highlight: '批量下载',
    subtitle: '批量导出更省时'
  }
]

const EnterprisePanel: React.FC<Props> = ({
  selectedGoods,
  onBuy,
  cardBanner
}) => {
  return (
    <div className="panel enterprise-panel">
      <div className="panel-content">
        <div className="enterprise-layout">
          <div className="enterprise-left">
            {cardBanner && (
              <div className="panel-card-banner">{cardBanner}</div>
            )}
            <div className="enterprise-qr-card">
              <div className="qr-img">
                <img src={wxCode} alt="enterprise-qr" />
              </div>
              <div className="qr-tip">请扫码添加企业级会员专属客服</div>
            </div>
          </div>
          <div className="enterprise-right">
            <h3 className="enterprise-title">
              企业级会员尊享 <span className="enterprise-highlight">30+</span>{' '}
              权益
            </h3>
            <div className="enterprise-benefits">
              {benefits.map((b, idx) => {
                const { title, highlight } = b
                const renderTitle = () => {
                  const h = highlight ? String(highlight).trim() : ''
                  if (h && title.includes(h)) {
                    const parts = title.split(h)
                    return (
                      <>
                        {parts[0]}
                        <span className="benefit-highlight">{h}</span>
                        {parts[1]}
                      </>
                    )
                  }
                  return (
                    <>
                      {title}
                      {h && <span className="benefit-highlight">{h}</span>}
                    </>
                  )
                }

                return (
                  <div className="enterprise-benefit" key={idx}>
                    <img src={b.img} className="benefit-img" alt={b.title} />
                    <div className="benefit-text">
                      <div className="benefit-title">{renderTitle()}</div>
                      <div className="benefit-subtitle">{b.subtitle}</div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EnterprisePanel
